import type { KyInstance } from 'ky';

import { ensureError } from '@enterprise/core';
import type { OperationResultWithData } from '@enterprise/types';

import type { District } from '#types/district.type';
import type { State } from '#types/state.type';

import { Uri } from '#constants/uri';

/**
 * Retrieves a list of districts for the specified states.
 *
 * @param kyInstance - An instance of Ky used to make HTTP requests.
 * @param states - An array of state objects, each containing an abbreviation property.
 * @returns A promise that resolves to the list of districts returned by the API.
 * @throws Throws an error if the request fails.
 */
export const getDistrictsByState = async (kyInstance: KyInstance, states: State[] = []) => {
  try {
    return await kyInstance
      .get<OperationResultWithData<District[]>>(Uri.lookup.districts, {
        searchParams: {
          states: states
            .map((state) => {
              return state.abbreviation;
            })
            .join(','),
        },
      })
      .json();
  } catch (e) {
    const error = ensureError(e);

    throw error;
  }
};
